export default {
  top: {
    index: 'INDEX',
    about: 'ABOUT US',
    introduce: 'introduce',
    development_history: 'development_history',
    abount_investor: 'abount_investor',
    innovation_lead: 'innovation_lead',
    company_honor: 'company_honor'
  },
  route: {
    AliIcons: 'AliIcons',
    list: 'list',
    Digitalanimation: 'Digitalanimation',
    Rollingpositioning: 'Rollingpositioning',
    PDF: 'PDF',
    HightLightinViewer: 'HightLightinViewer',
    contextmenu: 'contextmenu',
    simple: 'simple',
    divier: 'divier',
    group: 'group',
    submenu: 'submenu',
    disabled: 'disabled',
    customtrigger: 'custom-trigger',
    form: 'form',
    Tabs: 'Tabs',
    Table: 'Table',
    Icons: 'Icons',
    treeChart: 'treeChart',
    gaugeChart: 'gaugeChart',
    candleChart: 'candleChart',
    scatterChart: 'scatterChart',
    heatmapChart: 'heatmapChart',
    sankeyChart: 'sankeyChart',
    barGraph: 'barGraph',
    pieChart: 'pieChart',
    ringChart: 'ringChart',
    waterfallCharts: 'waterfallCharts',
    funnelCharts: 'funnelCharts',
    radarCharts: 'radarCharts',
    vueActual: 'vueActual',
    from: 'from',
    BaseForm: 'BaseForm',
    VueEditor: 'VueEditor',
    Upload: 'Upload',
    Components: 'Components',
    dragKanban: 'dragKanban',
    componentMixin: 'componentMixin',
    markdown: 'markdown',
    treeMen: 'treeMen',
    backToTop: 'backToTop',
    dashboard: 'dashboard',
    DiscountFigure: 'DiscountFigure',
    columnar: 'columnar',
    treeMenu: 'treeMenu',
    wel: 'wel',
    Lockscreenpage: 'Lockscreenpage',
    countenance: 'countenance',
    clipboard: 'clipboard',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    directivePermission: 'Directive Permission',
    complexTable: 'Complex Table',
    treeTable: 'Tree Table',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    thirdPartyWebsite: 'thirdPartyWebsite',
    charts: 'Charts',
    emoji: 'emoji',
    test: 'test',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    exportZip: 'Export Zip',
    i18n: 'i18n',
    Errorlog: 'Errorlog',
    svgicons: 'svgicons',
    fontawesome: 'fontawesome',
    pointMap: 'pointMap',
    roadBookMap: 'roadBookMap',
    cityLlistMap: 'cityLlistMap',
    baidumap: 'baidumap',
    gpsMap: 'gpsMap'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export selected items',
    placeholder: 'Please enter the file name(default excel-list)'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name(default file)'
  },
  permission: {
    roles: 'Your roles',
    switchRoles: 'Switch roles'
  },
  components: {
    documentation: 'documentation',
    tinymceTips: 'tinymceTips',
    dropzoneTips: 'dropzoneTips',
    stickyTips: 'stickyTips',
    backToTopTips1: 'backToTopTips1',
    backToTopTips2: 'backToTopTips2',
    imageUploadTips: 'imageUploadTips'
  },
  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  errorLog: {
    tips: 'tips',
    description: 'description',
    documentation: 'documentation'
  }
};